import { render, staticRenderFns } from "./dissmissed.vue?vue&type=template&id=898cd82e&"
import script from "./dissmissed.vue?vue&type=script&lang=js&"
export * from "./dissmissed.vue?vue&type=script&lang=js&"
import style0 from "./dissmissed.vue?vue&type=style&index=0&id=898cd82e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports